import { Logger } from "@moment/logging";

import type { QueryResponse } from "./request-page.types";

const logger = new Logger("template-responses");

export type TemplateResponsesFile = Record<string, Record<string, QueryResponse>>;

export function parseTemplateResponses(json: string): TemplateResponsesFile | undefined {
	try {
		const parsed = JSON.parse(json) as TemplateResponsesFile;
		if (typeof parsed !== "object" || parsed === null) {
			return undefined;
		}
		return parsed;
	} catch (err) {
		logger.error("Failed to parse template-responses.json", { err });
		return undefined;
	}
}

export function lookupTemplateResponse(
	responses: TemplateResponsesFile,
	pageId: string,
	key: string
): QueryResponse | undefined {
	return responses[pageId]?.[key];
}
